module.exports = __webpack_public_path__ + "img/cash-drawer.0027c4dd.svg";